import type { ModelDefinition } from '@mem-ai-hub/shared';
import { apiClient } from './api';

export async function getModels(): Promise<ModelDefinition[]> {
  const models = await apiClient.get<ModelDefinition[]>('/models');
  return models ?? [];
}
